import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Icon, ListItemIcon, ListItemText, Menu as MuiMenu, MenuItem } from '@material-ui/core';

export interface MenuProps {
    id: string
    anchorEl: HTMLElement | null
    handleClose: () => void
    options: MenuOption[]
}

export type MenuOption = {
    onClick: (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void,
    icon?: JSX.Element
    label: string
}

const Menu: FC<MenuProps> = ({ id, anchorEl, handleClose, options }) => {
    const classes = useStyles({});

    return (
        <MuiMenu
            id={id}
            elevation={2}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            getContentAnchorEl={null}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            {options.map((o, i) => (
                <MenuItem key={i} onClick={o.onClick}>
                    {o.icon ? (
                        <ListItemIcon></ListItemIcon>
                    ) : null}
                    <ListItemText>{o.label}</ListItemText>
                </MenuItem>
            ))}
        </MuiMenu>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({

}));

export default Menu;